import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { useNavigate } from 'react-router-dom';

import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';
import { getUserAccessLevel } from 'helper/user';
mapboxgl.accessToken = 'pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';

function getMapPolygons(group) {

    var polygon = {
        'type': 'FeatureCollection',
        'features': group.geojson
    }

    polygon.features.forEach(function (feature) {
        feature.properties = {
            group_id: group.group_id,
            name: group.name,
            // uuids: group.uuids
        };
    })

    return polygon;
}

function extendBounds(bounds, group) {
    group.geojson.forEach(function (feature) {
        feature.geometry.coordinates.forEach(function (coords) {
            coords.forEach(function (coord) {
                bounds.extend(coord);
            })
        })
    })
}

function ExploringMapEventGroups({ map, mapPadding, extraPadding, user_role = "viewer", groups_data, selectedEventGroups, sidebarOpen, menuToggled, setMenuToggled, setGroupPreviewID, deviceStyle = 'desktop' }) {

    const navigate = useNavigate();
    const set_padding = 100;

    const handleGroupClick = (e) => {
        setGroupPreviewID(e.features[0].properties.group_id);
        navigate("/explore/groups/" + e.features[0].properties.group_id);
    }

    const handleMapClick = (e) => {
        setGroupPreviewID(0);
        navigate("/explore/groups");
    }

    const handleMouseEnter = (e) => {
        map.current.getCanvas().style.cursor = 'pointer';
    }

    const handleMouseLeave = (e) => {
        map.current.getCanvas().style.cursor = '';
    }

    useEffect(() => {
        // console.log('MENU TOGGLED', menuToggled);
        var bounds = new mapboxgl.LngLatBounds();

        groups_data.forEach(function (group) {
            if (selectedEventGroups.indexOf(group.group_id) > -1) {
                extendBounds(bounds, group);
            }
        });

        if (map.current) {
            if (menuToggled) {
                if (deviceStyle == 'mobile') {
                    var padding = {
                        top: set_padding / 2,
                        bottom: set_padding / 2,
                        right: set_padding / 2,
                        left: set_padding / 2,
                    }
                }
                else {
                    if (extraPadding) {
                        var padding = {
                            top: set_padding,
                            bottom: mapPadding[1] + (1.5 * set_padding),
                            right: set_padding,
                            left: mapPadding[0] + set_padding,
                        }
                    }
                    else {
                        var padding = {
                            top: set_padding,
                            bottom: mapPadding[1] + set_padding,
                            right: set_padding,
                            left: mapPadding[0] + set_padding,
                        }
                    }
                }
                map.current.fitBounds(bounds, {
                    // linear: true,
                    padding: padding,
                    // duration: 1500
                });
                setMenuToggled(false);

            }
            else {
                map.current.easeTo({
                    padding: {
                        left: mapPadding[0],
                        bottom: mapPadding[1]
                    },
                    duration: 500
                });
            }
        }

    }, [sidebarOpen]);

    useEffect(() => {
        if (map.current) {
            // console.log(groups_data);
            groups_data.forEach(function (group) {
                var polygons = getMapPolygons(group);
                var existing_layer = map.current.getLayer('geojson-' + group.group_id);
                var existing_source = map.current.getSource('geojson-' + group.group_id);

                if (selectedEventGroups.indexOf(group.group_id) > -1) {
                    if (!group.all_updated) {
                        var colour = "#ff667c";
                    }
                    else if (group.devices_monitored > 0 && getUserAccessLevel(user_role, 'technician')) {
                        var colour = "#edaa00";
                    }
                    else {
                        var colour = "#58ba2d";
                    }
                }
                else {
                    var colour = 'grey';
                }
                // console.log(existing_layer)
                // console.log(existing_source)

                if (!existing_source) {
                    map.current.addSource('geojson-' + group.group_id, {
                        type: 'geojson',
                        data: polygons
                    });
                }
                if (!existing_layer) {
                    map.current.addLayer({
                        id: 'geojson-' + group.group_id,
                        type: 'fill',
                        source: 'geojson-' + group.group_id,
                        paint: {
                            "fill-opacity": 0.2,
                            "fill-color": colour
                        }
                    }).addLayer({
                        id: 'geojson-border-' + group.group_id,
                        type: 'line',
                        source: 'geojson-' + group.group_id,
                        paint: {
                            "line-color": colour,
                            "line-width": 2
                        }
                    });

                    // console.log(group.group_id);

                    // map.current.on('dblclick', 'geojson-' + group.group_id, handleGroupDblClick);
                    map.current.on('click', 'geojson-' + group.group_id, handleGroupClick);
                    map.current.on('mouseenter', 'geojson-' + group.group_id, handleMouseEnter);
                    map.current.on('mouseleave', 'geojson-' + group.group_id, handleMouseLeave);
                    map.current.on('click', handleMapClick);
                }

            });

        }
    }, []); //mount

    useEffect(() => () => { //unmount
        // console.log(groups_data)
        groups_data.forEach(function (group) {
            var existing_layer = map.current.getLayer('geojson-' + group.group_id);
            if (existing_layer) {
                // map.current.off('dblclick', 'geojson-' + group.group_id, handleGroupDblClick);
                map.current.off('click', 'geojson-' + group.group_id, handleGroupClick);
                map.current.on('mouseenter', 'geojson-' + group.group_id, handleMouseEnter);
                map.current.on('mouseleave', 'geojson-' + group.group_id, handleMouseLeave);
                map.current.off('click', handleMapClick);


                map.current.removeLayer('geojson-' + group.group_id);
                map.current.removeLayer('geojson-border-' + group.group_id);
                map.current.removeSource('geojson-' + group.group_id);
            }
        });

    }, []);
}

ExploringMapEventGroups.propTypes = {
    map: PropTypes.object,
    mapPadding: PropTypes.array,
    extraPadding: PropTypes.bool,
    user_role: PropTypes.string,
    groups_data: PropTypes.array,
    selectedEventGroups: PropTypes.array,
    bounds: PropTypes.object,
    sidebarOpen: PropTypes.bool,
    menuToggled: PropTypes.bool,
    setMenuToggled: PropTypes.func,
    setGroupPreviewID: PropTypes.func,
};

export default ExploringMapEventGroups;